function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "learn-icon",
  d: "M28.783,84.089,18.621,80.024a.34.34,0,0,0-.251,0L8.209,84.089a.339.339,0,0,0,0,.629l3.513,1.405v7.087a.338.338,0,0,0,.207.312A16.88,16.88,0,0,0,18.5,94.9a16.88,16.88,0,0,0,6.567-1.381.338.338,0,0,0,.207-.312V86.123l1.694-.677v2.726a1.355,1.355,0,1,0,.677,0v-3l1.142-.457a.339.339,0,0,0,0-.629Zm-4.19,8.894a16.133,16.133,0,0,1-6.1,1.243,16.133,16.133,0,0,1-6.1-1.243V86.394l5.971,2.388a.34.34,0,0,0,.251,0l5.971-2.388Zm3.387-3.5a.677.677,0,1,1-.677-.677A.677.677,0,0,1,27.979,89.484ZM18.5,88.1,9.246,84.4,18.5,80.7l9.249,3.7Z",
  transform: "translate(-7.996 -80)"
});

var SvgLearnIcon = function SvgLearnIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14.903,
    viewBox: "0 0 21 14.903",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLearnIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/learn-icon.dfea14cd.svg";
export { ForwardRef as ReactComponent };